import { Injectable } from '@angular/core';
import { GoogleAnalyticsProvider } from '../google-analytics/google-analytics';

/*
  Generated class for the OkageGoGoogleAnalyticsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OkageGoGoogleAnalyticsProvider extends GoogleAnalyticsProvider {

  constructor() {
    super();
  }

  /**
   * TOP pageview
   */
  public topPageView(referrer = "")
  {
    if (referrer){
      this.sendPageView(false, "/", referrer);
    }else{
      this.sendPageView(false, "/", "");
    }
  }


  /**
   * メニューレイアウト pageview
   */
  public menulayoutsPageView()
  {
    this.sendPageView(false, "/menulayouts");
  }

  /**
   * メニューレイアウト オーダーポップアップ pageview
   * @param menuName 
   */
  public menulayoutsDetailPopup(menuName)
  {
    this.sendPageView(false, "/menulayouts/detailPopup/"+menuName);
  }

  /**
   * カート画面 pageview
   */
  public sendOrderPageView()
  {
    this.sendPageView(false, "/send-order");
  }

  /**
   * 注文完了画面 pageview
   */
  public orderHistoryPageView(result = "")
  {
    this.sendPageView(false, "/order-history"+result);
  }

  /**
   * 注文ストップ PageView
   */
  public orderStopPageView(){
    this.sendPageView(false, "/order-stop");
  }

  /**
   * 店内支払い完了 PageView
   */
  public purchasePageView(){
    this.sendPageView(false, "/purchase");
  }

  /**
   * 支払い処理 Event
   */
  public paymentEvent(result, paymentType){
    result = (result) ? "complete" : "stop";
    this.sendEvent("payment", result, paymentType);
  }
}



// WEBPACK FOOTER //
// ./src/providers/okage-go-google-analytics/okage-go-google-analytics.ts